import {Module} from "vuex";
import {RootState} from "@/store/types";
import {customStatistic} from "@/store/custom/statistic";

export const customModule: Module<any, RootState> = {
  modules: {
    customStatistic,
  }
}
